import BannerUtils from './BannerUtils.js';
import BannerAdFactory from './BannerAdFactory.js';
import BannerRequest from './BannerRequest.js';

class BannerListeners {
    constructor(ctx) {
        this._ctx = ctx;
        this._apntag = ctx.apntag;
        this._allowedSSAProductTags = ctx.allowedSSAProductTags;
        this._appNexusData = ctx.appNexusData;
        this._radio = ctx.radio;

        this._TOPBAR_HEIGHT = 65;
        this._windowHeight = 0;
        this._state = {};
    }

    // Event listeners *********************

    // APPNEXUS: create onEvent listeners
    initApnListeners() {
        const allVisibleTags = BannerUtils.getAllVisbileTags();
        const tagsToClear = ['wallpaper', 'skyscraperleft_1'];
        const tagsToRenderWithFallback = ['board_2', 'netboard_2'];

        this._apntag.anq.push(() => {
            // ****** adNoBid --> clear
            tagsToClear.forEach(tagId => {
                this._apntag.onEvent('adNoBid', tagId, () => {
                    this._clearTags(tagId);
                });
            });

            // ****** adNoBid --> render fallback
            tagsToRenderWithFallback.forEach(tagId => {
                this._apntag.onEvent('adNoBid', tagId, () => {
                    const factory = new BannerAdFactory(this._ctx);
                    const ad = factory.createBlankFallback(tagId);
                    ad.render();
                });
            });

            // ****** adAvailable --> render
            allVisibleTags.forEach(tagId => {
                this._apntag.onEvent('adAvailable', tagId, adObj => {
                    // console.log(`adAvailable: ${tagId}`, adObj);
                    const factory = new BannerAdFactory(this._ctx);
                    const ad = factory.create(tagId, adObj);
                    ad.render();
                });
            });

            // ****** adLoaded --> track inview
            allVisibleTags.forEach(tagId => {
                this._apntag.onEvent('adLoaded', tagId, adObj => {
                    this._ctx.logger.logInview(tagId, adObj);
                    this._apntag.offEvent('adLoaded', tagId);
                });
            });
        });
    }

    _clearTags(tagId) {
        if (BannerUtils.pageContains(this._ctx, tagId)) {
            if (tagId === 'wallpaper') {
                let body;
                if (window === window.top) {
                    body = document.body;
                } else {
                    body = window.parent.document.body;
                }
                body.style.cssText = '';
            }
            if (tagId === 'skyscraperleft_1') {
                document.querySelector('#skyscraperleft_1').innerHTML = '';
            }
        }
    }

    // Refresh *********************

    refreshAfterSearch() {
        this._radio('pre-filter-and-search-changed').subscribe(result => {
            if (this._apntag && this._apntag.clearRequest) {
                this._apntag.clearRequest();
            }
            this._ctx.logger.unobserveBanners();
            this._clearNativeProduct(this._allowedSSAProductTags);
            this._clearEvents();

            this._ctx.initAppNexusData(result);
            this.initApnListeners();

            const bannerRequest = new BannerRequest(this._ctx);
            bannerRequest.perform();

            this._radio('banner-reload-static').broadcast();
        });
    }

    refreshAfterGalleryClosed() {
        this._radio('gallery.closed').subscribe(() => {
            const validData = Object.keys(this._appNexusData).length > 0;
            if (this._appNexusData && validData) {
                this._apntag.anq.push(() => {
                    this._apntag.setPageOpts(this._appNexusData.pageOpts);
                    this._apntag.refresh();
                });
            }
        });
    }

    _clearEvents() {
        this._apntag.anq.push(() => {
            this._apntag.offEvent('adNoBid');
            this._apntag.offEvent('adAvailable');
            this._apntag.offEvent('adLoaded');
        });
    }

    _clearNativeProduct() {
        const ele = BannerUtils.getSSAProductTag(this._allowedSSAProductTags);
        if (ele != null) {
            while (ele.firstChild) {
                ele.removeChild(ele.firstChild);
            }
        }
    }

    // Sticky skyscraper *********************

    observeStickySkyscrapers() {
        let scrollTimer;
        const SCROLL_TIMEOUT = 30;
        const SKY_BOTTOM_STICKY_THRESHOLD = 700 + this._TOPBAR_HEIGHT;
        this._windowHeight = window.innerHeight;
        if (this._windowHeight <= SKY_BOTTOM_STICKY_THRESHOLD) {
            window.addEventListener('scroll', () => {
                clearInterval(scrollTimer);
                scrollTimer = setTimeout(
                    () => this._bottomSticky(this),
                    SCROLL_TIMEOUT
                );
            });
            this._stickyBannerPos();
        }
    }

    _positions() {
        const positions = {};
        const elements = Array.from(
            document.querySelectorAll('[data-astbanner-name]')
        );
        elements.forEach(element => {
            const tagId = element.getAttribute('data-astbanner-name');
            positions[tagId] = element;
        });
        return positions;
    }

    _stickyBannerPos(item, scrollTop) {
        let el;
        const renderedHeight = item && item.clientHeight;

        if (!renderedHeight) {
            return;
        }
        let name;
        if (item) {
            name = item.getAttribute('id');
        }

        if (
            this._state[name] === false &&
            scrollTop + this._windowHeight >
                renderedHeight + this._TOPBAR_HEIGHT
        ) {
            // set bottom sticky
            this._state[item.getAttribute('data-astbanner-name')] = true;
            el = item.parentNode;

            el.style.position = 'fixed';
            el.style.bottom = '0';
            el.style.height = `${renderedHeight}px`;
        }

        if (
            typeof this._state[item.getAttribute('data-astbanner-name')] ===
                'undefined' ||
            (this._state[item.getAttribute('data-astbanner-name')] === true &&
                scrollTop + this._windowHeight <
                    renderedHeight + this._TOPBAR_HEIGHT)
        ) {
            this._state[item.getAttribute('data-astbanner-name')] = false;
            el = item.parentNode;
            el.style.position = 'absolute';
            el.style.bottom = '';
        }
    }

    _bottomSticky(instance) {
        const scrollTop = window.pageYOffset;
        const positions = instance._positions();
        instance._stickyBannerPos(positions.skyscraperleft_1, scrollTop);
        instance._stickyBannerPos(positions.skyscraperright_1, scrollTop);
    }

    // *********************
}

export default BannerListeners;



// WEBPACK FOOTER //
// ./services/banner2/BannerListeners.js